<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách mẫu hiện trạng ticket</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('CNPS_TICKET_CREATE')"
          @click="create"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              data-toggle="tooltip"
              data-placement="top"
              title="Mã hiện trạng, tên hiện trạng"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="category form-group">
            <Select2MultipleControl
              :settings="{ placeholder: 'Danh mục ticket', closeOnSelect: false }"
              v-model="search.applyFor"
              :options="Config.getSearch(dataTypeCode)"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(applyFor)="data">
                <span class="text-center">
                  {{ data.item.applyForText ? data.item.applyForText.join() : '' }}
                </span>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.status">
                  {{ data.item.status | transformData(Config.statusCurrentState) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item class="dropdown-item" @click="editCurrentState(data.item.id)"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="data.item.status === 'ACTIVE'"
                    @click="changeStatus(data.item.id, data.item.status)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Khóa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="data.item.status === 'UN_ACTIVE'"
                    @click="changeStatus(data.item.id, data.item.status)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Mở khóa
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { TicketService } from '@/services/ticket.service'
  import cloneDeep from 'lodash/cloneDeep'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã hiện trạng', thStyle: 'min-width: 150px' },
    { key: 'name', label: 'Hiện trạng', thStyle: 'min-width: 150px' },
    { key: 'description', label: 'Mô tả', thStyle: 'min-width: 150px' },
    { key: 'applyFor', label: 'Áp dụng cho danh mục', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'ticket-current-state',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataTypeCode: [],
        search: {
          pageSize: 20,
          pageIndex: 1,
        },
        pagination: {
          total: 0,
        },
      }
    },
    watch: {
      'search.pageIndex': function () {
        this.fetchData()
      },
    },
    created() {
      this.search.userId = this.dataUser.userId
      TicketService.fetchCategory()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name })) ?? [])
        .then(s => (this.dataTypeCode = s))
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async submitForm() {
        this.search.pageIndex = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          pageSize: 20,
          pageIndex: 1,
        }
        await this.fetchData()
      },
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await TicketService.fetchCurrentStateTicket(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      create() {
        this.$router.push({ path: `/ticket-current-state/create` })
      },
      async changeStatus(id, status) {
        this.showLoading = true
        try {
          const params = { id }
          if (status == 'ACTIVE') {
            params.status = 'UN_ACTIVE'
          } else params.status = 'ACTIVE'
          const response = await TicketService.changeStatusCurrentStateTicket(params)
          if (response.code === 1000) {
            this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      editCurrentState(id) {
        this.$router.push({ path: `/ticket-current-state/${id}` })
      },
    },
  }
</script>
<style scoped>
  .c-poiter {
    cursor: pointer;
  }
  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }
  .UN_ACTIVE {
    color: #fff;
    background-color: #dc3545;
  }
  .category {
    width: 300px;
  }
</style>
